import { Factory } from "lucide-react";
import CreditModule from "@/components/CreditModule";

export default function KasbonPabrik() {
  return <CreditModule type="supplier" icon={Factory} />;
}
